import React from 'react';
import { API_BASE_URL } from '../config';

export default function UserAvatar({
  userId,
  userName = '',
  srcOverride,
  className = 'avatar',
  style,
}) {
  const fallbackSrc = `https://i.pravatar.cc/100?u=${userId || userName || 'user'}`;
  const defaultSrc = userName ? `/images/${userName}.png` : '';
  const apiSrc = userId ? `${API_BASE_URL}/api/Members/${userId}/image` : '';
  const primarySrc = srcOverride || apiSrc || defaultSrc || fallbackSrc;

  return (
    <img
      src={primarySrc}
      className={className}
      style={style}
      alt={userName || 'User'}
      onError={(e) => {
        e.target.onerror = null;
        if (e.target.src !== fallbackSrc) {
          e.target.src = fallbackSrc;
        }
      }}
    />
  );
}
